import { COMPANY_PROFILE_CONFIG } from './company';
import { CONTACT_PROFILE_CONFIG } from './contact';

// WIP: Entries are added as each entity's pure-layer PR lands (Company and Contact first; then
// Hiring Authority, Candidate, Job Order per the approved build order).
export const ENTITIES = {
  company: COMPANY_PROFILE_CONFIG,
  contact: CONTACT_PROFILE_CONFIG
};
export {
  COMPANY_DRAWERS,
  COMPANY_PROFILE_CONFIG,
  COMPANY_QUERY_PARAMS,
  COMPANY_TAB_IDS
} from './company';
export {
  ALLOWED_TASKS_BY_CONTACT_ROLE,
  CONTACT_DRAWERS,
  CONTACT_PROFILE_CONFIG,
  CONTACT_QUERY_PARAMS,
  CONTACT_TAB_IDS
} from './contact';
